export enum ShootExecutionStatus {
  DRAFT = "DRAFT",
  PLANNED = "PLANNED",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}
